import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-692ad002"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-mt-6",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  style: {"font-size":"2em"},
  class: "p-text-center"
}, "LES FONCTIONNALITES", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-center p-px-4" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.5em","max-width":"1000px","font-weight":"50"} }, " Transformez votre tablette ou ordinateur en un véritable terminal de caisse performant et compatible avec vos imprimantes tickets, lecteurs de codes barres et tiroirs de caisse . ")
], -1))
const _hoisted_4 = { class: "p-d-flex p-flex-column p-ai-center p-justify-center p-my-3" }
const _hoisted_5 = { class: "p-col-12 p-md-6 p-d-flex p-justify-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "p-col-12 p-md-6 p-d-flex p-justify-center p-flex-column p-ai-center" }
const _hoisted_8 = { style: {"width":"95%"} }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "p-d-flex p-justify-center p-mt-4 p-mx-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"line-height":"1.8"} }, " Découvrez toute la puissance de notre application de caisse en ligne maintenant et bénéficiez de 30 jours d'utilisation gratuite sans engagement et sans carte de crédit. De plus, notre équipe est disponible pour vous accompagner gratuitement dans l'apprentissage ou le réglage de votre caisse. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chip = _resolveComponent("chip")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["p-grid p-my-6", { 'p-flex-row-reverse': item.reverse }]),
          key: index,
          style: {"min-width":"90%"}
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "p-m-1 card",
              src: require(`../../assets/home/${item.img}`),
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_chip, {
                class: "title p-ml-3",
                label: _ctx.$t(`workspaceLayout.${item.title}`),
                image: require(`../../assets/home/${item.img}`)
              }, null, 8, ["label", "image"]),
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.body, (b, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(b), 1))
                }), 128))
              ])
            ])
          ])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Message, {
        style: {"max-width":"1550px"},
        closable: false
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ])
  ]))
}